import { useState } from 'react';
import { WorkflowsTypes } from '../../types/general';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';
import TransitionComponent from '../../components/TransitionComponent/TransitionComponents';
import WorkflowCategory from '../../components/Workflow/WorkflowCategory';

const Workflows = () => {
    const [selectedType, setSelectedType] = useState<undefined | null | WorkflowsTypes>(undefined);
    const navigate = useNavigate();

    const handleCategoryChange = (type: WorkflowsTypes) => (e: any) => {
        setSelectedType(type);
        navigate(
            type === WorkflowsTypes.Fill
                ? '/storage/create'
                : type === WorkflowsTypes.View
                  ? '/dashboard?t=storage'
                  : '/workflows',
        );
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <TransitionComponent inProp={!selectedType} isAbsolute={!!selectedType}>
                    <div className={styles.categoriesWrapper}>
                        <div className={styles.categories}>
                            <WorkflowCategory onClick={handleCategoryChange} />
                        </div>
                    </div>
                </TransitionComponent>
            </div>
        </div>
    );
};

export default Workflows;
